<template>
   <v-container grid-list-xl>
    <!-- test layout -->
      <h2>Seznam vpisanih uporabnikov</h2>
      <v-divider></v-divider>
      <br>
    <v-layout v-bind="contentLayout">
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <!--uporabniki-->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Išči..."
              single-line
              hide-details
            ></v-text-field>
            
          </v-card-title>
              <div>
              <v-data-table
                :headers="headers"
                :items="uporabniki"
                :search="search"
                no-results-text="Ni podatkov."
                rows-per-page-text="Prikaz zapisov"
                :rows-per-page-items="rowsPerPage"
                :loading="loading"

              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.imetnik }}</td>
                  <td class="text-xs-left">{{ (props.item.omejitve != null) ? props.item.omejitve.Naziv_omejitve : '' }}</td>
                  <td class="text-xs-left">{{ props.item.id_kartice }}</td>
                  <td class="text-xs-left">{{ props.item.serijska_st_kartice }}</td>
                  <td class="text-xs-left">{{ props.item.registrska_st_1 }}</td>
                  <td class="text-xs-left">{{ props.item.registrska_st_2 }}</td>
                  <td class="text-xs-left">{{ props.item.registrska_st_3 }}</td>
                  <td class="text-xs-left">{{ props.item.registrska_st_4 }}</td>
                  <td class="text-xs-left">{{ props.item.registrska_st_5 }}</td>
                  <td class="text-xs-left">
                    
                      <v-icon class="pointer" flat icon color="indigo" @click="editItem(props.item)" small>edit</v-icon>
                      &nbsp;&nbsp;&nbsp;
                      <v-icon class="pointer" flat icon color="error"  @click="deleteItem(props.item)" small>delete</v-icon>
                  
                  </td>
                </template>
                <div slot="no-results" :value="true" style="text-align:center;">
                    Nobeden zapis ne ustreza iskanemu nizu.
                </div>
                <div slot="no-data" style="text-align:center;">
                  Ni podatkov za prikaz.
                </div>
                <template slot="pageText" slot-scope="props">
                  Prikazujem {{ props.pageStart }} - {{ props.pageStop }} od {{ props.itemsLength }}
                </template>
              </v-data-table>
            </div>
        </v-card>
      </v-flex>
      <v-tooltip left>
          <v-btn
          fixed
          dark
          fab
          bottom
          right
          color="light-blue darken-3"
          @click="addUser"
          slot="activator"
          >
          <v-icon>group_add</v-icon>
          </v-btn>
          <span>Vpis novih uporabnikov</span>
      </v-tooltip>
    </v-layout>
    <!-- snackbar success -->
      <v-snackbar
          v-model="snackbar_success.display"    
          :bottom="snackbar_success.y === 'bottom'"
          :left="snackbar_success.x === 'left'"
          :multi-line="snackbar_success.mode === 'multi-line'"
          :right="snackbar_success.x === 'right'"
          :timeout="snackbar_success.timeout"
          :top="snackbar_success.y === 'top'"
          :vertical="snackbar_success.mode === 'vertical'"
      >
          {{ snackbar_success.text }}
          <v-btn
          color="pink"
          flat
          @click="snackbar_success.display = false"
          >
          Zapri
          </v-btn>
      </v-snackbar>

      <!-- snackbar error -->
      <v-snackbar
          v-model="snackbar_error.display"  
          :bottom="snackbar_error.y === 'bottom'"
          :left="snackbar_error.x === 'left'"
          :multi-line="snackbar_error.mode === 'multi-line'"
          :right="snackbar_error.x === 'right'"
          :timeout="snackbar_error.timeout"
          :top="snackbar_error.y === 'top'"
          :vertical="snackbar_error.mode === 'vertical'" 
          color="error"
      >
          {{ snackbar_error.text }}
          <v-btn
          dark
          flat
          @click="snackbar_error.display = false"
          >
          Zapri
          </v-btn>
      </v-snackbar>
      <v-dialog v-model="dialog" persistent max-width="490">
        <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
        <v-card>
          <!--<v-card-title class="headline">Ste prepričani da želite izbrisati uporabnika?</v-card-title>-->
          <v-card-text>
            <v-icon flat>delete_forever</v-icon>
            {{ dialog_text }}
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat @click.native="dialogCancel()">Prekliči</v-btn>
            <v-btn color="primary darken-1" flat @click.native="dialogConfirm(itemToDelete)">Nadaljuj</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
export default {
    data () {
      return {
        barcode: '',
        valid: true,
        search: '',
        loading: false,
        headers: [
          { text: 'Imetnik', value: 'imetnik', sortable: true },
          { text: 'Tip omejitve', value: 'omejitve', sortable: true },
          { text: 'ID kartice', value: 'id_kartice', sortable: true },
          { text: 'Št. kartice', value: 'serijska_st_kartice', sortable: true },
          { text: 'Registrska št. 1', value: 'registrska_st_1', sortable: true },
          { text: 'Registrska št. 2', value: 'registrska_st_2', sortable: true },
          { text: 'Registrska št. 3', value: 'registrska_st_3', sortable: true },
          { text: 'Registrska št. 4', value: 'registrska_st_4', sortable: true },
          { text: 'Registrska št. 5', value: 'registrska_st_5', sortable: true },
          { text: 'Upravljanje', value: 'upravljanje', sortable: false }

        ],

        rowsPerPage: [10, 15, 25, 50, 100],
        validacijeLoadingError: false,
        snackbar_success: {
            display: false,
            y: 'bottom',
            x: "right",
            mode: '',
            timeout: 6000,
            text: "Uporabnik  je bil uspešno vnesen v sistem.",
        },
        itemToDelete: null,
        snackbar_error: {
            display: false,
            y: 'bottom',
            x: "right",
            mode: '',
            timeout: 6000,
            text: "Pri vnosu uporabnika v sistem je prišlo do napake.",
        },
        dialog: false,
        dialog_title: '',
        dialog_text: '',
        dialog_confirm: false
      }
    },

    watch: {
    },

    computed: {
      currentUser() {
        return this.$store.getters.user.name
      },

      parkirisce: {
        get() {
          let parkirisce = this.$store.getters.parkirisce
          return parkirisce
        },

        set(newValue) {
          this.$store.commit('setParkirisce', newValue)
        }

      },

      contentLayout () {
        const binding = {}

        if(this.$vuetify.breakpoint.lgAndUp) {
          binding.column = false
        } else {
          binding.column = true
        }

        return binding;
      } ,

      disableScan() {
        return (this.parkirisce == null) ? false : true;
      },

      uporabniki() {
        return this.$store.getters.uporabniki
      },
      
      /*validacijeError() {
        return this.validacijeLoadingError
      }*/
    },

    methods: {
      addUser() {
          this.$router.push({
              name: 'rfid'
          })
      },

      editItem(item) {
        this.$router.push({
          name: 'uporabnik',
          params: {
            uuid: item.uuid
          }
        })
      },

      deleteItem(item) {
        this.itemToDelete = item
        this.dialog_text = 'Ste prepričani da želite odstraniti uporabnika ' + item.imetnik + '?'
        this.dialog = true
      },

      dialogConfirm() {
        this.dialog_confirm = true
        this.dialog = false
        this.$store.dispatch('DESTROY_RFID_UPORABNIK', this.itemToDelete.uuid)
        .then(response => {
            this.snackbar_success.text = 'Uporabnik ' + this.itemToDelete.imetnik + ' je bil odstranjen iz sistema.'
            this.snackbar_success.display = true
            this.loading = true
            this.itemToDelete = null
            this.$store.dispatch('RFID_UPORABNIKI')
              .then(response => {
                this.loading = false
              })
              .catch(error => {
                this.loading = false
              })
        })
        .catch(error => {
            window.console.log(error)
            this.snackbar_error.text = 'Pri brisanju uporabnika ' + this.itemToDelete.imetnik + ' je prišlo do napake.'
            this.snackbar_error.display = true
            this.deleteUserLoading = false
            this.itemToDelete = null
        })

      
      },

      dialogCancel() {
        this.dialog_confirm = false
        this.dialog = false
        this.itemToDelete = null
      }
    },

    created() {
      this.loading = true
      this.$store.dispatch('RFID_UPORABNIKI')
        .then(response => {
          window.console.log(response.data)
          this.loading = false
        })
        .catch(error => {
          window.console.log(error)
          this.loading = false
        })
    },

    mounted() {
    }
  }
</script>

<style scoped>
     h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }

    .pointer {cursor: pointer;}
</style>


